// extracted by mini-css-extract-plugin
export default {"section":"PortMonitorIncidents_section__zY4wv"};